import { TimeStampModifiers } from "../../../../data";
export function modifierDatePeriodTimes(masterEvent) {
    return masterEvent.isLive
        ? TimeStampModifiers.modifierLiveTime
        : TimeStampModifiers.modifierDatePeriod;
}
export function modifierTimeScore(masterEvent) {
    return masterEvent.isLive
        ? TimeStampModifiers.modifierScore
        : TimeStampModifiers.modifierTime;
}
//# sourceMappingURL=getDateModifiers.js.map